(function () {
    'use strict';

    // @ngInject
    function StartFromFileWizardModalControllerCtor($scope, $injector, $modalInstance, $state,
                                            AnalyticsService, UsersManager, WorkspaceFilesManager, CompaniesManager,
                                            OnboardingService, WorkspaceFileService, PopupMessageService, AppStates,
                                            fileType, workspace, _, EventsManager, EventService, Enums, FacebookPixelTrackingService, WorkspacesManager, FeaturesService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'StartFromFileWizardModalController';

        AnalyticsService.trackPageView(
            this,
            'StartFromFileWizardModalView',
            {
                source: fileType.source || 'create file',
                file_type: fileType.type
            }
        );

        this.$scope = $scope;
        this.AnalyticsService = AnalyticsService;
        this.$modalInstance = $modalInstance;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.UsersManager = UsersManager;
        this.OnboardingService = OnboardingService;
        this.WorkspaceFileService = WorkspaceFileService;
        this.PopupMessageService = PopupMessageService;
        this.AppStates = AppStates;
        this.AnalyticsService = AnalyticsService;
        this._ = _;
        this.EventsManager = EventsManager;
        this.EventService = EventService;
        this.Enums = Enums;
        this.FacebookPixelTrackingService = FacebookPixelTrackingService;
        this.FeaturesService = FeaturesService;

        this.user = this.UsersManager.getCurrUser();
        this.company = CompaniesManager.getCurrCompany();
        this.fileType = fileType;
        this.workspace = workspace;

        this.steps = [{
                title : "Create New ",
                errorMessage : "",
                isValidAndSubmitted : true
            },
            {
                title : "What project is this file for?",
                errorMessage : "",
                isValidAndSubmitted : true
            }];


        this._init();

        WorkspacesManager.getWorkspacesCounts(this.user._id).then(function success(resp) {
            this.workspaceCount = resp.data.counts.active;
        }.bind(this));

    }

    Controllers.StartFromFileWizardModalController = Class(Controllers.BaseController, {
        constructor: StartFromFileWizardModalControllerCtor,

        _init: function _init() {

            if ( this.fileType.create_file_from_templates ) {
                this.currentStep = 2;
                this.showPreviousStep = false;
                this.fileOriginModelId =  this.fileType.template_id;
                this.fileOriginType = this.Enums.createFileOriginType.template;

            } else {
                this.showPreviousStep = true;
                this.currentStep = 1;
            }

            this.startFromNewProject = true;
            this.startFromProjectId = null;
            this.creatingFileInProgress = false;

            this.createFileFromWorkspace = !!this.workspace;

        },

        onComplete: function onComplete(fileOriginType, modelId) {
            this.fileOriginType = fileOriginType;
            this.fileOriginModelId = modelId;

            if(this.createFileFromWorkspace) {
                this.createFile();
                return;
            }

            this._switchStep(2);
        },

        onCancel: function onCancel() {
            this.dismissModal();
        },

        dismissModal: function dismissModal() {
            this.$modalInstance.dismiss();
        },

        _switchStep: function (stepNum) {
            this.currentStep = stepNum;
        },

        previous: function previous() {
            this._switchStep(this.currentStep - 1);
        },

        createFile: function createFile() {

            var templateId, resentFileId, promise;

            if (this.fileOriginType === this.Enums.createFileOriginType.template) {
                templateId = this.fileOriginModelId;
            } else if(this.fileOriginType === this.Enums.createFileOriginType.file) {
                resentFileId = this.fileOriginModelId;
            }

            if (this.createFileFromWorkspace) {
                promise = this.WorkspaceFileService.createFile(this.fileType.type, this.workspace, resentFileId, templateId, this.user, false);
                this._handleCreateFilePromise(promise);
                return;
            }

            if (this.startFromNewProject) {
                if (!this.newProjectName) {
                    // The new modal prevents submission with no "New project" name
                    this.errorMessage = "CREATE_FILE_WIZARD.SELECT_PROJECT._NEW_PROJECT_ERROR_"
                    this.AnalyticsService.track(
                        this,
                        'error: template modal new project name'
                    );
                    return;
                }
                var projectData =
                    this.EventService.createDefaultProject(
                        this.company,
                        this.newProjectName,
                        this.EventService.getDefaultProjectTypeLabel(this.company)
                    );
                promise = this.WorkspaceFileService.createFileWithProject(this.fileType.type, resentFileId, templateId, projectData.dataOnly());
                this._handleCreateFilePromise(promise);
            } else {
                if (!this.startFromProjectId) {
                    this.errorMessage = "CREATE_FILE_WIZARD.SELECT_PROJECT._EXISTING_PROJECT_ERROR_"
                    this.AnalyticsService.track(
                        this,
                        'error: template modal existing project name'
                    );
                    return;
                }
                var eventPromise = this.EventsManager.getEvent(this.startFromProjectId, false, true);
                eventPromise.then(function getEventSuccess(event) {
                    var workspace = event.workspaces[0];
                    promise = this.WorkspaceFileService.createFile(this.fileType.type, workspace, resentFileId, templateId, this.user);
                    this._handleCreateFilePromise(promise);
                }.bind(this));
            }

            this.AnalyticsService.track(
                this,
                'click: create file in project ',
                {
                    source: (this.startFromNewProject ? 'new project' : 'existing project')
                }
            );

        },

        clearErrorMessage: function clearErrorMessage() {
            this.errorMessage = null;
        },

        _handleCreateFilePromise: function _handleCreateFilePromise(promise) {
            this.creatingFileInProgress = true;

            var analyticsArgs = {
                origin: this.fileOriginType,
                file_type: this.fileType.type
            };

            if(!this.createFileFromWorkspace) {
                analyticsArgs.should_create_project = this.startFromNewProject
            }

            promise.then(function() {
                this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.create_workspace_file, analyticsArgs);
                if (['invoice','proposal','agreement'].indexOf(analyticsArgs.file_type)  !== -1){
                    this.FacebookPixelTrackingService.trackCustom('BookableFileCreated');
                }
                this.$modalInstance.close();
            }.bind(this))
            .catch(function(error) {
                this.errorMessage = error.data.error_message;
                this.AnalyticsService.trackError(
                    this.$scope, 
                    this.AnalyticsService.analytics_events.create_workspace_file, 
                    analyticsArgs
                );
            }.bind(this))
            .finally(function() {
                this.creatingFileInProgress = false;
            }.bind(this));
        },

        projectChanged: function projectChanged() {

        },

    });
}());
